import { AnyAction } from 'redux'
import types from '../actions/actionTypes'

export interface IState {
  device: {
    isMobile: boolean
    isPad1: boolean
    isPad2: boolean
    isDesktop: boolean
  }
  innerWidth: number
  innerHeight: number
}

export const LayoutInitialState = {
  device: {
    isMobile: false,
    isPad1: false,
    isPad2: false,
    isDesktop: false
  },
  innerWidth: 0,
  innerHeight: 0
}

const LayoutReducer = (
  state: IState = LayoutInitialState,
  action: AnyAction
) => {
  switch (action.type) {
    case types.SET_VIEW_PORT:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default LayoutReducer
